import { connect } from 'react-redux';
import General from '../../../components/event/after-action/general';
import {
    updateAfterAction,
    approveAfterAction,
    requestInfoAfterAction,
    updateAndSubmitAfterAction,
    setEventUserAction,
    setEventErrorMessage,
    setAAAproverVal,
    toggleAARequestModal,
    toggleAAApproveModal,
    setFormFieldValidity
} from '../../../actions';

import {
    getEventActions,
    getEventStatus,
    getEventForm
} from '../../../reducers';

const mapStateToProps = state => ({
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasAfterActionActions,
    errorMessage: state.events.errorMessage,
    userIsCreator: state.events.userIsCreator,
    userAction: state.events.userAction,
    approvers: state.events.aaApprovers,
    tasks: state.events.aaTasks,
    aaStatus: state.events.aaStatus,
    requestModalActive: state.events.aaRequestModalActive,
    approveModalActive: state.events.aaApproveModalActive,
    jwtToken: state.auth.jwtToken,
    eventId: state.events.id,
    afterActionUserID: state.event.EventReport.userId,
    groupStatus: state.events.groupStatus,
    eventState: state.event,
    eventForm: getEventForm(state)
});

const mapDispatchToProps = dispatch => ({
    updateAfterAction: data => dispatch(updateAfterAction(data)),
    approveAfterAction: data => dispatch(approveAfterAction(data)),
    requestInfoAfterAction: data => dispatch(requestInfoAfterAction(data)),
    submitAfterAction: data => dispatch(updateAndSubmitAfterAction(data)),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    setEventErrorMessage: msg => dispatch(setEventErrorMessage(msg)),
    setApproverVal: val => dispatch(setAAAproverVal(val)),
    toggleRequestModal: () => dispatch(toggleAARequestModal()),
    toggleApproveModal: () => dispatch(toggleAAApproveModal()),
    setFormFieldValidity: (model, bool) =>
        dispatch(setFormFieldValidity(model, bool))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(General);



// WEBPACK FOOTER //
// ./src/containers/event/after-action/general.js